import React from 'react'

const MenuInclude = props => {
  if (!props.allMenuData || !props.allMenuData.length) return null
  if (!props.functionParams || !props.functionParams.length) return null
  const menuName = props.functionParams[0]
  const matchingMenu = props.allMenuData.find((menu) => {
    return menu.id.endsWith(menuName)
  })

  if (!matchingMenu) return null
  const menuHtml = matchingMenu.attributes.html

  return (
    <div id='menuContent' dangerouslySetInnerHTML={{ __html: menuHtml }} />
  )
}

export default MenuInclude



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/menuInclude.jsx